import React from 'react'
import styled from '@emotion/styled'
import Container from '../components/shared/container'
import { mediaQueries } from '../theme'
import SignupsClosedComponent from '../components/auth/signups-closed'
import Layout from '../components/layout'
import PageMetadata from '../components/page-metadata'

const InnerContainer = styled(Container)`
  padding: 0;
  margin-bottom: ${p => p.theme.space[18]};

  ${mediaQueries.lg} {
    margin-bottom: ${p => p.theme.space[24]};
  }
`

const SignupsClosed = styled(SignupsClosedComponent)`
  width: 21.875rem;
  margin: 0 auto;
  ${mediaQueries.sm} {
    width: 31.25rem;
  }
  ${mediaQueries.lg} {
    width: auto;
  }
`

const StartPage = ({ location }) => {
  const next = new URLSearchParams(location.search).get('next')

  return (
    <Layout location={location}>
      <PageMetadata
        title="Signups Closed"
        description="New signups are currently closed. Stay tuned for updates."
        keywords="getform"
      />
      <InnerContainer>
        <SignupsClosed next={next} />
      </InnerContainer>
    </Layout>
  )
}

export default StartPage
